import { render } from "./DirectionsButton.vue?vue&type=template&id=55243e65"
import script from "./DirectionsButton.vue?vue&type=script&lang=ts"
export * from "./DirectionsButton.vue?vue&type=script&lang=ts"
script.render = render

export default script